import script from "./history.vue?vue&type=script&setup=true&lang=js"
export * from "./history.vue?vue&type=script&setup=true&lang=js"

import "./history.vue?vue&type=style&index=0&id=0f01ed76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f01ed76"]])

export default __exports__